import { dialog } from "./dialog";
import { button } from "./button";
import { checkbox } from "./checkbox";
import { drawer } from "./drawer";
export const customTheme = {
  button,
  checkbox,
  drawer,
  dialog,
};
